import { signOut } from 'firebase/auth';
import React from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import { useAuthState } from 'react-firebase-hooks/auth';

import { Link } from 'react-router-dom';
import auth from '../../firebase.init';


const Header = () => {
    const [user] = useAuthState(auth);
    const handleSignOut = () => {
        signOut(auth);
    }


    return (
        <Navbar sticky='top' collapseOnSelect expand="lg" className='bg-success text-white' variant="dark">
            <Container>
                <Navbar.Brand as={Link} to="/">
                    <h2>
                        FRIDGE BD
                    </h2>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className="me-auto ">
                        <Nav.Link as={Link} to="/home">Home</Nav.Link>
                        <Nav.Link as={Link} to="/blog">Blog</Nav.Link>
                        <Nav.Link href="home#faq">FAQ</Nav.Link>


                    </Nav>
                    <Nav>

                        {
                            user ?
                                <span>

                                    <button className='bg-success border-0'><Nav.Link as={Link} to="/additems">Add Items</Nav.Link></button>

                                    <button className='bg-success border-0'><Nav.Link as={Link} to="/myitems">My Items</Nav.Link></button>

                                    <button className='bg-success border-0'><Nav.Link as={Link} to="/manageitems">Manage Items</Nav.Link></button>

                                    <button className='btn btn-link text-white text-decoration-none' onClick={handleSignOut}>Sign Out</button>
                                </span>
                                :
                                <Nav.Link eventKey={2} href="/login">
                                    Login
                                </Nav.Link>
                        }




                    </Nav>

                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default Header;